var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"api-login"}},[_c('main',{staticClass:"container"},[_c('p',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.message)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }